<div
  id="pdp-homr-rich-content"
  class="full-long-description hmf-mb-l hmf-mb-m-xl hmf-p-m-xl hmf-p-m hmf-p-s">

  <!-- Template A -->
  @if (homrRichContent?.templateA !== undefined) {
    <div>
      <common-accordion [isDisabled]="true">
        @if (panelHeader) {
          <div class="hmf-py-s description-header hmf-display-flex hmf-justify-content-center" [ngClass]="{'pl-rich-content' : chain?.chainIdentifierAbbr === 'pl'}" myPanelHeader [innerHTML]="panelHeader | bypassSanitization"></div>
        }
        <div myPanelBody>
          <pdp-tech-icons [techIconsArray]="homrRichContent?.templateA?.techIcons"></pdp-tech-icons>
          <!-- Show secondary headline if tech specs row exists -->
          @if (hasTechSpecsRow) {
            <div>
              <div class="hmf-px-s description-header hmf-display-flex hmf-justify-content-center" [innerHTML]="homrRichContent?.templateA?.categoriesHeader?.header | bypassSanitization"></div>
              <hr>
              </div>
            }
            @for (halfImageText of homrRichContent?.templateA?.halfImageHalfTextArray; track trackByFn($index, halfImageText)) {
              <div class="image-viewer-swatch-col">
                <div class="hmf-flex-wrap halfImage halfImage--{{ halfImageText?.imagePosition }}">
                  @if (halfImageText.image || halfImageText.visualAssets || halfImageText.youtubeId || halfImageText.animation) {
                    <shared-media-component-media
                      class="hmf-col hmf-span-xlg-6 hmf-span-lg-12 hmf-display-flex hmf-justify-content-center hmf-align-items-center"
                      [visualAssets]="halfImageText?.visualAssets"
                      [altText]="halfImageText?.altText"
                      [image]="halfImageText?.image"
                      [mobileImg]="halfImageText?.mobileImg"
                      [itemTitle]="halfImageText?.headline"
                      [youtubeId]="halfImageText?.youtubeId"
                      [animation]="trending?.animation"
                      [imagePagePosition]="5"
                      [willLazyLoad]="true">
                    </shared-media-component-media>
                  }
                  <div class="hmf-col hmf-span-xlg-6 hmf-span-lg-12 hmf-display-flex hmf-flex-column hmf-justify-content-center">
                    <div class="header" [innerHTML]="halfImageText?.headline | bypassSanitization"></div>
                    <div class="meta" [innerHTML]="halfImageText?.description | bypassSanitization"></div>
                  </div>
                </div>
              </div>
            }
            <pdp-trending [trendingArray]="homrRichContent?.templateA?.trendingArray"></pdp-trending>
          </div>
        </common-accordion>
      </div>
    }

    <!-- Template B-->
    @if (homrRichContent?.templateB !== undefined) {
      <div class="hmf-span-12 hmf-position-relative hmf-p-0 hmf-display-flex hmf-flex-column hmf-justify-content-center hmf-align-items-center">
        <common-accordion [isDisabled]="true">
          <div class="hmf-px-s description-header hmf-header-bold-m-m hmf-header-bold-s hmf-display-flex hmf-justify-content-center pl-header" [ngClass]="{'hmf-display-m-s hmf-display-xs' : chain?.chainIdentifierAbbr === 'pl'}" myPanelHeader [innerHTML]="panelHeader | bypassSanitization"></div>
          <pdp-tech-icons [techIconsArray]="homrRichContent?.templateB?.techIcons"></pdp-tech-icons>
          <!-- Show secondary headline if tech specs row exists -->
          @if (hasTechSpecsRow) {
            <div>
              <div class="hmf-px-s description-header hmf-display-flex hmf-justify-content-center" [innerHTML]="homrRichContent?.templateB?.categoriesHeader?.header | bypassSanitization"></div>
              <hr>
              </div>
            }
            <div myPanelBody class="panel-body">
              @if (homrRichContent?.templateB?.fullStory?.image || homrRichContent?.templateB?.fullStory?.visualAssets || homrRichContent?.templateB?.fullStory?.youtubeId || homrRichContent?.templateB?.fullStory?.animation) {
                <shared-media-component-media
                  class="hmf-p-0 hmf-display-flex hmf-justify-content-center"
                  [visualAssets]="homrRichContent?.templateB?.fullStory?.visualAssets"
                  [altText]="homrRichContent?.templateB?.fullStory?.altText"
                  [image]="homrRichContent?.templateB?.fullStory?.image"
                  [mobileImg]="homrRichContent?.templateB?.fullStory?.mobileImg"
                  [itemTitle]="homrRichContent?.templateB?.fullStory?.headline"
                  [youtubeId]="homrRichContent?.templateB?.fullStory?.youtubeId"
                  [animation]="homrRichContent?.templateB?.fullStory?.animation"
                  [imagePagePosition]="5"
                  [willLazyLoad]="true">
                </shared-media-component-media>
              }
              <div class="hmf-display-flex hmf-justify-content-center">
                <div class="hmf-display-flex hmf-justify-content-center fullStory-headline" [innerHTML]="homrRichContent?.templateB?.fullStory?.headline | bypassSanitization"></div>
              </div>
              <div class="hmf-display-flex hmf-justify-content-center">
                <div class="hmf-mb-m-m hmf-mb-s hmf-p-0 hmf-display-flex hmf-justify-content-center fullStory-subCopy" [innerHTML]="homrRichContent?.templateB?.fullStory?.subCopy | bypassSanitization"> </div>
              </div>
              <pdp-trending [trendingArray]="homrRichContent?.templateB?.trendingArray"></pdp-trending>
            </div>
          </common-accordion>
        </div>
      }
    </div>
